export enum PaymentType {
    SUBSCRIPTION = 'SUBSCRIPTION',
    CREDIT = 'CREDIT',
}
